export default "public/warning_1.svg";